module.exports = __webpack_public_path__ + "img/3.3289f0a6.png";